// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip__IgbC0","buttons":"Tooltip_buttons__PdQWW","body":"Tooltip_body__BrdhH","name":"Tooltip_name__7q9K4"};